import { render, staticRenderFns } from "./destinations.vue?vue&type=template&id=d2d2b6a6&lang=html&"
import script from "./destinations.vue?vue&type=script&lang=js&"
export * from "./destinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports